import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Factory, MapPin } from "lucide-react";
import { Reveal, SectionLabel } from "../site/Reveal";
import { COMPANY } from "../../data/products";

const SITES = [
  { city: "Noida", state: "Uttar Pradesh", role: "Head office & manufacturing", ranges: "PALATIVA · AVITIVA" },
  { city: "AURIC, Aurangabad", state: "Maharashtra", role: "Manufacturing", ranges: "OPTIBITE" },
];

export const Company = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="company" ref={ref} data-testid="company-section" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 relative h-[420px] md:h-[560px] overflow-hidden rounded-[28px]">
        <motion.img style={{ y }} src="/images/lab.jpg" alt="Feed science laboratory" className="absolute inset-0 h-[116%] -top-[8%] w-full object-cover" />
        <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-[rgba(251,248,241,0.92)] backdrop-blur-md p-5 flex items-center gap-4">
          <MapPin className="text-[var(--amber)] shrink-0" />
          <p className="text-sm text-[var(--ink)]">{COMPANY.address}</p>
        </div>
      </div>
      <div className="lg:col-span-6">
        <SectionLabel index="06">Company</SectionLabel>
        <Reveal as="h2" className="font-display text-4xl sm:text-5xl font-light tracking-tight text-[var(--forest)] leading-[1.05] mt-8">
          Our offices &amp; <span className="italic">manufacturing</span>
        </Reveal>
        <Reveal as="p" className="mt-6 text-[var(--muted)] leading-relaxed max-w-xl" delay={0.1}>
          Gait Naurish Ltd. develops and manufactures palatability, aquaculture and poultry performance additives for feed manufacturers, integrators and farms. Every product is built for the conditions of real mills — heat, steam, extrusion and storage — and backed by clear dosage guidance.
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {SITES.map((s, i) => (
            <Reveal key={s.city} delay={i * 0.1} className="rounded-2xl border border-[var(--line)] bg-[var(--paper)] p-6">
              <Factory className="text-[var(--leaf)]" size={22} />
              <p className="font-display text-2xl text-[var(--forest)] mt-4">{s.city}</p>
              <p className="text-sm text-[var(--muted)]">{s.state}</p>
              <p className="font-mono text-xs mt-4 text-[var(--moss)]">{s.role}</p>
              <p className="font-mono text-xs text-[var(--amber)] mt-1">{s.ranges}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
